/* av1kit.js — advertorial interactivity (no inline script; loaded once via the first section).
   - Reveals any scroll-hidden / faded content (static clone has no builder runtime).
   - Routes every CTA link & button inside the advertorial (.av1) to the product page.
   - Injects a floating sticky CTA bar.
   Re-runs on Shopify's section-load event so it also works inside the theme customizer. */
(function () {
  var PRODUCT = '/products/airovine';
  var STICKY_LABEL = 'DÉCOUVRIR SIVENA →';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  // ── reveal scroll-hidden / faded content ────────────────────────────
  function reveal(root) {
    (root || document).querySelectorAll('.av1 [style*="opacity:0"],.av1 [style*="opacity: 0"],'
      + '.av1 .gps-lazy,.av1 [data-gp-reveal],.av1 [class*="gp-animate"]').forEach(function (el) {
      el.style.setProperty('opacity', '1', 'important');
      el.style.setProperty('transform', 'none', 'important');
      el.style.setProperty('visibility', 'visible', 'important');
      if (el.classList) el.classList.remove('gps-lazy');
    });
  }

  // ── route every CTA to the product page (keep mailto:/tel:) ─────────
  function isMailTel(href) { return /^(mailto:|tel:)/i.test(href || ''); }
  function wireLinks(root) {
    (root || document).querySelectorAll('.av1 a').forEach(function (a) {
      var href = a.getAttribute('href') || '';
      if (isMailTel(href)) return;
      a.setAttribute('href', PRODUCT);
    });
    if (!window.__av1BtnClicks) {
      window.__av1BtnClicks = true;
      document.addEventListener('click', function (e) {
        var b = e.target.closest('.av1 button, .av1 [role="button"]');
        if (!b) return;
        var a = e.target.closest('.av1 a');
        if (a && !isMailTel(a.getAttribute('href'))) return; // link handles navigation
        e.preventDefault();
        window.location.href = PRODUCT;
      }, true);
    }
  }

  // ── floating sticky CTA bar ─────────────────────────────────────────
  function stickyBar() {
    if (document.getElementById('av1-sticky-cta')) return;
    var bar = document.createElement('a');
    bar.id = 'av1-sticky-cta';
    bar.href = PRODUCT;
    bar.textContent = STICKY_LABEL;
    bar.setAttribute('aria-label', 'Découvrir Sivena');
    document.body.appendChild(bar);
    var st = document.createElement('style');
    st.textContent =
      '#av1-sticky-cta{position:fixed;left:50%;bottom:16px;transform:translateX(-50%);z-index:99999;'
      + 'display:block;max-width:560px;width:calc(100% - 32px);box-sizing:border-box;text-align:center;'
      + 'padding:15px 24px;border-radius:999px;background:#a98232;color:#fff;font-weight:800;'
      + 'font-family:inherit;font-size:17px;letter-spacing:.02em;text-decoration:none;'
      + 'box-shadow:0 8px 24px rgba(68,57,43,.35);transition:background .2s,transform .2s;}'
      + '#av1-sticky-cta:hover{background:#c6a451;transform:translateX(-50%) translateY(-2px);}'
      + '@media(max-width:749px){#av1-sticky-cta{font-size:16px;padding:14px 18px;bottom:10px;}}';
    document.head.appendChild(st);
  }

  function initAll(root) {
    reveal(root);
    wireLinks(root);
  }

  ready(function () { initAll(document); stickyBar(); });
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target || document); });
})();
